(() => {
  const words = ['Training', 'Lashes', 'Brows', 'Starter Kits', 'Lotions', 'Henna'];
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const initializeSearchPlaceholders = () => {
    document.querySelectorAll('.header-search-inline__input').forEach((input) => {
      const basePlaceholder = input.dataset.placeholderPrefix || 'Search...';
      let wordIndex = 0;
      let characterIndex = 0;
      let deleting = false;
      let timer;

      const stopAnimation = () => window.clearTimeout(timer);
      const animate = () => {
        if (input.value || document.activeElement === input) {
          input.placeholder = basePlaceholder;
          timer = window.setTimeout(animate, 250);
          return;
        }

        const word = words[wordIndex];
        characterIndex += deleting ? -1 : 1;
        input.placeholder = `${basePlaceholder} ${word.slice(0, characterIndex)}`;

        let delay = deleting ? 55 : 90;
        if (!deleting && characterIndex >= word.length) {
          deleting = true;
          delay = 1300;
        } else if (deleting && characterIndex <= 0) {
          deleting = false;
          wordIndex = (wordIndex + 1) % words.length;
          delay = 250;
        }

        timer = window.setTimeout(animate, delay);
      };

      if (reduceMotion) {
        input.placeholder = basePlaceholder;
        return;
      }

      input.placeholder = basePlaceholder;
      input.addEventListener('focus', () => {
        stopAnimation();
        input.placeholder = basePlaceholder;
      });
      input.addEventListener('blur', () => {
        if (!input.value) animate();
      });
      animate();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSearchPlaceholders, { once: true });
  } else {
    initializeSearchPlaceholders();
  }
})();
